<template>
  <div>
    <Form :model="form" inline>
      <FormItem label="关键字" prop="keyword" label-position="right" :label-width="60">
        <Input v-model="form.keyword" placeholder="请输入查询关键字"></Input>
      </FormItem>

      <FormItem>
        <Button type="primary" @click="openEditInfoModal()">新增扩展信息</Button>
      </FormItem>
    </Form>

    <Table stripe :loading="loading" :columns="columns" :data="data"></Table>
    <div style="float: left;margin: 10px;overflow: hidden">
      <Page show-sizer placement="top" :total="count" :current="page" :page-size="pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>

    <Modal v-model="editInfoModal.display" :title="editInfoModal.title" ref="editInfoModal" :loading="true" @on-ok="preEditInfo" @on-cancel="cancelEditInfo">
      <Form :label-width="100">
        <FormItem label="类型" prop="type">
          <Select v-model="editInfoModal.checkType" filterable>
            <Option :value="1">电信网络账号</Option>
            <Option :value="2">乐视电视账号</Option>
          </Select>
        </FormItem>

        <FormItem label="开始结束日期" prop="time">
          <DatePicker v-model="editInfoModal.time" @on-change="dateRange => {changeDate(dateRange)}" :clearable="false" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 320px"></DatePicker>
        </FormItem>

        <FormItem label="提醒类型" prop="remindType">
          <Select v-model="editInfoModal.remindType" filterable>
            <Option :value="1">指定月份号数</Option>
            <Option :value="2">指定周期天数</Option>
          </Select>
        </FormItem>

        <FormItem label="名称" prop="name">
          <Input :value="editInfoModal.name"></Input>
        </FormItem>

        <FormItem label="周期天数" prop="timeNum">
          <InputNumber v-model="editInfoModal.timeNum" :min="0"></InputNumber>
        </FormItem>

        <FormItem label="账号" prop="account">
          <Input :value="editInfoModal.account"></Input>
        </FormItem>

        <FormItem label="密码" prop="password">
          <Input :value="editInfoModal.password"></Input>
        </FormItem>

        <FormItem label="设备个数" prop="devices">
          <InputNumber v-model="editInfoModal.devices" :min="0"></InputNumber>
        </FormItem>

        <FormItem prop="remark" label="备注：">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="editInfoModal.remark"></Input>
        </FormItem>

      </Form>
    </Modal>
  </div>
</template>

<script>
import Moment from 'moment'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {
        keyword: ""
      },
      columns: [
        {
          title: "扩展信息ID",
          key: "id",
          align: "center",
          width: 150,
        },
        {
          title: "类型",
          key: "type",
          align: "center",
          width: 150,
        },
        {
          title: "名称",
          key: "name",
          align: "center",
          width: 150,
        },
        {
          title: "开始日期",
          key: "startDate",
          align: "center",
          width: 150,
        },
        {
          title: "结束日期",
          key: "endDate",
          align: "center",
          width: 150,
        },
        {
          title: "上次缴费时间",
          key: "payDate",
          align: "center",
          width: 150,
        },
        {
          title: "提醒类型",
          key: "remindType",
          align: "center",
          width: 150,
        },
        {
          title: "周期(天)",
          key: "period",
          align: "center",
          width: 150,
        },
        {
          title: "提醒日",
          key: "remindDay",
          align: "center",
          width: 150,
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          width: 150,
        },
        {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        console.info(params);
                      }
                    }
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        console.info(params)
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
      ],
      page: 1,
      pageSize: 10,
      editInfoModal: {
        display: false,
        title: '新增扩展信息',
        name: '',
        time: [],
        payTime: '',
        remindType: '',
        timeNum: 0,
        account: '',
        password: '',
        devices: 0,
        remark: '',
      }
    };
  },
  methods: {
    changeDate(dateRange) {
      if (!dateRange[0]) {
        this.editInfoModal.time = [];
      }
    },
    changePage(pageIndex) {
      this.goodsList.page = pageIndex;
    },
    changePageSize(pageSize) {
      this.goodsList.page = 1;
      this.goodsList.pageSize = pageSize;
    },
    openEditInfoModal(payload={}) {
      this.initEditInfoModal(payload);

      this.editInfoModal.display = true;
    },
    initEditInfoModal(payload={}) {
      const defaultDate = [
        Moment().format('YYYY-MM-DD'),
        Moment().add(15, 'day').format('YYYY-MM-DD')
      ];

      this.editInfoModal = Object.assign(this.editInfoModal, {
        title: '新增扩展信息',
        name: '',
        time: defaultDate,
        payTime: '',
        remindType: '',
        timeNum: 0,
        account: '',
        password: '',
        devices: 0,
        remark: '',
      }, payload)
    },
    preEditInfo() {},
    cancelEditInfo() {}
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/room/room-detail/extension-info.vue